<div class="card mb-3">
    <div class="card-header">
        <h6 class="card-title mb-0">Participantes da Central de Compras</h6>
    </div>

    <ng-template [ngIf]="isLoading">
        <div class="card-body">
            <p class="card-text">
                <i class='fas fa-spinner fa-pulse'></i> Pesquisando participantes
            </p>
        </div>
    </ng-template>

    <ng-template [ngIf]="!isLoading">
        <div class="table-responsive">
            <table class="table table-striped table-hover table-bordered">
                <thead>
                    <tr>
                        <th class="col-participante">Participante</th>
                        <th class="col-perc-participacao text-right">Participação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let participante of participantes; let i = index">
                        <td class="col-participante">
                            {{participante.nome | clienteNome:participante.nomeFantasia:participante.codigoIntegracaoErp}}
                            <small>
                                {{participante.nome | clienteNomeSecundario:participante.nomeFantasia}}
                            </small>
                        </td>                            
                        <td class="col-perc-participacao text-right">
                            {{participante.percParticipacaoCentralCompra | decimalFormat: 1:0:0}}%                                           
                        </td> 
                    </tr>
                    <tr *ngIf="participantes?.length === 0" class="no-record">
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Nenhum participante encontrado
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="col-participante"></td>
                        <td class="col-perc-participacao text-right">
                            {{(percParticipacaoTotalCentralCompra ? percParticipacaoTotalCentralCompra : 0) | decimalFormat: 1:0:0}}%
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </ng-template>
</div>